import React from 'react';

import Tooltip from '../../../../../../Tooltip';

import downloadDocument from '../../../../../../../helpers/downloadDocument';
// import SystemService from '../../../../../../../services/SystemService';

/* const downloadByUrl = async (path, name) => {
  const signedUrl = await SystemService.getSignedUrlFromPath(path);

  const downloadLink = document.createElement('a');

  downloadLink.href = signedUrl;
  downloadLink.download = name;
  downloadLink.target = '_blank';
  downloadLink.rel = 'noopener noreferrer';

  document.body.appendChild(downloadLink);

  downloadLink.click();

  document.body.removeChild(downloadLink);
}; */

export default function DownloadLetterButton({ document }) {
  if (!document?.id) {
    return <Tooltip>This document is missing</Tooltip>;
  }

  return (
    <button
      type="button"
      className="text-slate-400 hover:text-slate-500 dark:text-slate-500 dark:hover:text-slate-400 rounded-full"
      onClick={() => {
        downloadDocument(document.id, document.name);
      }}
    >
      <span className="sr-only">Download</span>
      <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
        <path d="M16 20c.3 0 .5-.1.7-.3l5.7-5.7-1.4-1.4-4 4V8h-2v8.6l-4-4L9.6 14l5.7 5.7c.2.2.4.3.7.3zM9 22h14v2H9z" />
      </svg>
    </button>
  );
}
